import { readSubmitPage } from "./submit-data";

export function getSubmitPage({
  data,
  signal,
}: {
  data: { href: string };
  signal?: AbortSignal | undefined;
}) {
  return readSubmitPage({ href: data.href, signal });
}
